import ScrollReveal from "@/components/feature/ScrollReveal";
import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES } from "@/mocks/site";
import { orderSteps } from "@/mocks/menu";

export default function HowToOrder() {
  return (
    <section id="como-pedir" className="w-full bg-background-50 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-10">
        <ScrollReveal className="max-w-3xl">
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-accent-500">
            Sin complicaciones
          </p>
          <h2 className="mt-4 font-heading text-4xl leading-[1.05] text-foreground-950 md:text-6xl">
            Pedir es así de simple
          </h2>
        </ScrollReveal>

        <div className="mt-12 grid grid-cols-1 gap-10 md:mt-16 md:grid-cols-3 md:gap-12">
          {orderSteps.map((step, index) => (
            <ScrollReveal key={step.id} delay={index * 90}>
              <div className="flex h-full flex-col">
                <span
                  className="font-heading text-6xl leading-none text-primary-500 md:text-7xl"
                  aria-hidden="true"
                >
                  {step.number}
                </span>
                <h3 className="mt-6 font-heading text-2xl text-foreground-950 md:text-3xl">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                  {step.text}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal className="mt-14 flex justify-center">
          <a
            href={whatsappUrl(WA_MESSAGES.general)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-[54px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-10 text-base font-medium text-background-50 transition-colors duration-300 hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
            Pedir ahora por WhatsApp
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
}